import React, {useState} from 'react';
import {Outlet, useLoaderData, useNavigate} from 'react-router-dom';
import Footer from "../Footer";
import Navbar from "../Navbar";
import CoursesMenu from "../CoursesMenu";
import UserMenu from "../UserMenu";
import {
  ThemeProvider,
  useAuthenticator,
  View,
} from '@aws-amplify/ui-react';
import LicenseBanner from "../LicenseBanner";
import {defaultTheme} from "../../themes/default";
import styles from './index.module.css';
import 'react-modern-drawer/dist/index.css'

const Layout = () => {
  const [theme] = useState(defaultTheme);
  const [navbarHidden, setNavbarHidden] = useState(false);
  const [courseMenuOpen, setCourseMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const {signOut} = useAuthenticator((context) => [
    context.signOut,
  ]);

  const navigate = useNavigate();

  const logOut = () => {
    signOut();
    navigate('/login');
  }

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  document.addEventListener("scroll", function () {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      setNavbarHidden(true)
    } else if (st < lastScrollTop) {
      setNavbarHidden(false)
    }
    lastScrollTop = st <= 0 ? 0 : st;
  }, false);

  const minHeightToHideNavbar = (window.innerHeight * 30) / 100;
  const hidden = navbarHidden && window.scrollY >= minHeightToHideNavbar;

  return (
    <ThemeProvider theme={theme}>
      <Navbar
        hidden={hidden}
        courseMenuOpen={courseMenuOpen}
        setCourseMenuOpen={setCourseMenuOpen}
        userMenuOpen={userMenuOpen}
        setUserMenuOpen={setUserMenuOpen}
      />
      <CoursesMenu
        courseMenuOpen={courseMenuOpen}
        setCourseMenuOpen={setCourseMenuOpen}
      />
      <UserMenu
        userMenuOpen={userMenuOpen}
        setUserMenuOpen={setUserMenuOpen}
        logOut={logOut}
      />
      <View
        className={styles.contentView}
      >
        <LicenseBanner/>
        <Outlet/>
        <Footer/>
      </View>
    </ThemeProvider>
  );
}

export default Layout;